import React from 'react';

export type CountBadgeVariant = 'active' | 'muted';

interface CountBadgeProps {
  count: number;
  /**
   * "active" = amber-500 pill with white / dark text (used on the selected
   * tab or any primary-highlighted context).
   * "muted"  = neutral chip that flips to a light zinc surface on dark mode
   * so the count stays legible against the dark tab strip.
   */
  variant?: CountBadgeVariant;
  className?: string;
}

/**
 * Small numeric pill used after labels (tab counts, section eyebrows, etc.).
 * Pulled out so every count chip in the activity-tab system reads the same
 * in both light and dark mode.
 */
export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  variant = 'muted',
  className = '',
}) => {
  const tone =
    variant === 'active'
      ? 'bg-amber-500 text-white dark:text-zinc-900'
      : 'bg-foreground/15 text-foreground dark:bg-zinc-200 dark:text-zinc-900';

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full text-[10px] font-semibold tabular-nums transition-colors ${tone} ${className}`}
    >
      {count}
    </span>
  );
};
